import { render, staticRenderFns } from "./EditQuestions.vue?vue&type=template&id=0e0f48a8&"
import script from "./EditQuestions.vue?vue&type=script&lang=js&"
export * from "./EditQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0f48a8')) {
      api.createRecord('0e0f48a8', component.options)
    } else {
      api.reload('0e0f48a8', component.options)
    }
    module.hot.accept("./EditQuestions.vue?vue&type=template&id=0e0f48a8&", function () {
      api.rerender('0e0f48a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Security/SecurityQuestions/EditQuestions.vue"
export default component.exports